import { colors } from "@mui/material";
import { Colors } from "assets/colors";

export const styles: any = {
    errContainer: {
        color: "red", 
        fontSize: ".9rem", 
        display: "block", 
        position: 'absolute',
        right:'200px',
        background: "rgb(255, 244, 229)", 
        padding:"15px 50px",
        justifyItems: 'normal',
        borderRadius: "5px",
        margin: '0px auto',
        boxShadow: '1px 2px 1px #ccc',
        zIndex: '999'
      },
      csvbutton: {
        color: "white",
        background:colors.purple,
        textTransform: "capitalize",
        marginRight: "1rem",
        alignItems: "center",
        minWidth: "170px",
        "&:hover": {
          color: Colors.BlackText,
        }
      }
} 
